// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { sessionConfigSelector } from '../../selectors/configSelectors';
import { isActive } from '../../utils/targetUtils';
import useNow from '../../hooks/useNow';
import Duration from '../ui/Duration';


type Props = $ReadOnly<{
    sessionStart?: number,
    lastUpdate?: string,
    className?: string,
}>;

function Session({ sessionStart, lastUpdate, className }: Props) {
    const sessionConfig = useSelector(sessionConfigSelector);
    const now = useNow();
    const sessionDuration = typeof sessionStart !== 'undefined' ? (now - sessionStart) : undefined;
    const duration = (isActive(lastUpdate, sessionConfig) && typeof sessionDuration !== 'undefined') ? Math.max(0, sessionDuration) : undefined;

    return <Duration className={className} duration={duration} />;
}

export default Session;